module.exports = __webpack_public_path__ + "static/img/02.052257b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/solution/low-code/02.jpg
// module id = 2y6N
// module chunks = 1